import { Grid, GridColumn, Notice, Separator } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import RoamingStore from '../../stores/RoamingStore';
import EeaCountryCard from './EeaCountryCard';
import NonEeaCountryCard from './NonEeaCountryCard';

interface RoamingCountryCardProps {
  roamingStore?: RoamingStore;
}

@observer
class RoamingCountryCard extends React.Component<RoamingCountryCardProps> {
  public render() {
    const {
      roamingStore: { selectedCountry, operatorList }
    } = this.props;
    if (!selectedCountry) {
      return null;
    }
    return (
      <>
        <Separator spacing={'medium'} color={'invisible'} />
        {operatorList.description && this.renderDescriptionNotice()}
        {selectedCountry.eea ? <EeaCountryCard isoCode={selectedCountry.isoCode} /> : <NonEeaCountryCard />}
      </>
    );
  }

  private renderDescriptionNotice = () => {
    const {
      roamingStore: { operatorList }
    } = this.props;

    return (
      <Grid align={['center-xs']}>
        <GridColumn width={['md-7']}>
          <Notice>
            <span dangerouslySetInnerHTML={{ __html: operatorList.description }} />
          </Notice>
          <Separator spacing={'xsmall'} color={'invisible'} />
        </GridColumn>
      </Grid>
    );
  };
}

export default inject('roamingStore')(RoamingCountryCard);
